import { Threat, ThreatsData } from "@sportal/api";
import { LoadingState } from "../shared/withLoadableSlice.types";
import { ChangeLanguageSuccessAction } from "../attributes/attributes.types";

export type ThreatsMap = Record<string, Threat>;

export interface ThreatsListReducerState extends LoadingState {
  list: ThreatsMap;
  keys: number[];
}

export const FETCH_THREATS = "[THREATS] FETCH_THREATS";
export const FETCH_THREATS_SUCCESS = "[THREATS] FETCH_THREATS_SUCCESS";
export const FETCH_THREATS_FAILURE = "[THREATS] FETCH_THREATS_FAILURE";

interface FetchThreatsRequestAction {
  type: typeof FETCH_THREATS;
}

interface FetchThreatsSuccessAction {
  type: typeof FETCH_THREATS_SUCCESS;
  payload: ThreatsData;
}

interface FetchThreatsFailureAction {
  type: typeof FETCH_THREATS_FAILURE;
  payload: object & { code: number | string };
}

export type ThreatsActionTypes =
  | FetchThreatsRequestAction
  | FetchThreatsSuccessAction
  | FetchThreatsFailureAction
  | ChangeLanguageSuccessAction;
